export default {
  path: "/setting",
  redirect: "/setting/dict",
  meta: {
    icon: "ri:settings-3-fill",
    showLink: true,
    title: "系统设置",
    rank: 900
  },
  children: [
    {
      path: "/setting/dict",
      name: "Dict",
      component: () => import("@/views/setting/dict/index.vue"),
      meta: {
        title: "字典管理",
        showParent: true,
        icon: "mdi:book"
      }
    },
    {
      path: "/setting/user",
      name: "User",
      component: () => import("@/views/setting/user/index.vue"),
      meta: {
        title: "用户管理",
        showParent: true,
        icon: "ri:user-settings-fill"
      }
    }
  ]
} satisfies RouteConfigsTable;
